import { useEffect, useState } from 'react'
import { cn } from '~/@/lib/utils'
import { DossSignalType, useDossSignals } from '~/common/hooks/useDossSignals'
import { LeftNav } from '../left-nav/LeftNav'

/**
 * Mobile navigation panel that slides in from the left.
 * Thin presentational wrapper around LeftNav — handles backdrop, enter/exit
 * transitions, and exposes a close action that's routed into LeftNav's header.
 */
export const MobileNav = () => {
  const { dispatch } = useDossSignals()
  const [mounted, setMounted] = useState(false)
  const [closing, setClosing] = useState(false)

  // Trigger enter animation on first frame after mount
  useEffect(() => {
    requestAnimationFrame(() => setMounted(true))
  }, [])

  const close = () => setClosing(true)

  // When the slide-out transition ends, dispatch the signal to unmount
  const handleTransitionEnd = () => {
    if (closing) {
      dispatch(DossSignalType.TOGGLE_MOBILE_MENU, false)
    }
  }

  const isVisible = mounted && !closing

  return (
    <div
      className={cn(
        'fixed inset-0 z-[1300] flex transition-opacity duration-[120ms]',
        isVisible ? 'opacity-100' : 'opacity-0',
      )}
    >
      {/* Panel */}
      <div
        className={cn(
          'flex w-72 shadow-xl transition-transform duration-[120ms]',
          isVisible ? 'translate-x-0 ease-out' : '-translate-x-full ease-in',
        )}
        onTransitionEnd={handleTransitionEnd}
      >
        <LeftNav expanded isMobile onClose={close} />
      </div>

      {/* Backdrop */}
      <div className="flex-1 bg-black/20" onClick={close} />
    </div>
  )
}
